import { Routes, Route } from 'react-router-dom';
import Leads from 'views/leads';
import NotFound from 'views/not-found';

const LeadsRoutes = (): JSX.Element => (
	<Routes>
		<Route element={<Leads />} index />
		<Route element={<NotFound />} path="*" />
	</Routes>
);

export default LeadsRoutes;
